import React from 'react'
import { Card, CardTitle, CardText, CardBody } from 'reactstrap'
import { getCurrencySign } from 'common'
import useTranslation from '../hooks/UseTranslation'
import { getPackTypeStr } from '../translations/utils'

export const PackLogo = ({ packType }) => {
  const icon = {
    online: 'webcam',
    physical: 'house',
    all: 'star'
  }[packType]
  return (
    <div className='icon-rounded bg-secondary-light mb-3'>
      <div className='icon-rounded bg-secondary-light mb-3'>
        <svg className='svg-icon text-secondary w-2rem h-2rem'>
          <use xlinkHref={`/content/svg/orion-svg-sprite.svg#${icon}-1`} />
        </svg>
      </div>
    </div>
  )
}

export const getPackValidityDurationStr = (t, validityDuration) => {
  // find closest from 1 week, 2 weeks, 3 weeks, 1 month, ... 11 months, 1 year
  const months = [0.25, 0.5, 0.75, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  const validityDurationMonth = validityDuration / 3600 / 24 / 31
  const closest = months.reduce((prev, curr) =>
    Math.abs(curr - validityDurationMonth) < Math.abs(prev - validityDurationMonth)
      ? curr
      : prev
  )
  if (closest === 0.25) return t('validity_1_week')
  if (closest === 0.5) return t('validity_{}_weeks', 2)
  if (closest === 0.75) return t('validity_{}_weeks', 3)
  if (closest === 1) return t('validity_1_month')
  return t('validity_{}_months', closest)
}

const PackCard = (props) => {
  const { t } = useTranslation()
  const { pack } = props

  const onClick = props.onClick ? () => props.onClick(pack) : () => null
  const onEdit = props.onEdit ? () => props.onEdit(pack) : () => null

  const packTypeStr = getPackTypeStr(pack.pack_type, t)

  return (
    <Card
      className={`h-100 border-0 shadow hover-animate ${props.onClick ? 'pointer' : ''
        }`}
      key={props.key}
      onClick={onClick}
    >
      <CardBody className='d-flex flex-column justify-content-between'>
        {/* {card.warning && <i style={{ color: "red", position: "absolute", right: "-0.1rem", top: "0.5rem" }} className={`fa fa-exclamation-circle fa-fw mr-2`} />} */}
        <CardTitle className='mb-2 dashboard-title' tag='h6'>
          <PackLogo packType={pack.pack_type} />
          <div className='d-flex justify-content-between'>
            <span className='text-decoration-none text-first-letter'>
              {pack.name ?? t('packs_n_classes_display', pack.n_classes)}
            </span>
          </div>
        </CardTitle>
        <CardText className='text-muted d-flex flex-column justify-content-between h-100'>
          <div>
            <span className='text-first-letter text-black font-weight-bold'>
              {packTypeStr}
            </span>
            <span>{t('packs_n_classes', pack.n_classes)}</span>

            {pack.validity_duration && (
              <div className='text-sm'>
                <span>
                  {getPackValidityDurationStr(t, pack.validity_duration)}
                </span>
              </div>
            )}

            {pack.is_unique_use && (
              <div className='text-sm'>
                <span>
                  {t('packs_is_unique_use').toLowerCase()}
                </span>
              </div>
            )}
          </div>
          <div className='h5 text-primary text-right'>
            {/* fixme: currency harcoded */}
            {t('price_display', pack.price, getCurrencySign('EUR'))}
          </div>
        </CardText>
      </CardBody>
      <div className='close-absolute pt-1'>
        {props.onEdit && (
          <i
            className='fa fa-pen pointer text-muted'
            onClick={(e) => {
              e.stopPropagation()
              onEdit()
            }}
          />
        )}
        {props.onDelete && (
          <i
            className='fa fa-trash fa-fw mx-2 pointer text-error'
            onClick={(e) => {
              e.stopPropagation()
              props.onDelete(e, pack)
            }}
          />
        )}
      </div>
    </Card>
  )
}

export default PackCard
